(ns quuppa.peweb.peinfo-logs
  (:require ["react" :as react]
            [clojure.string :as str]
            [goog.string :as gstring]
            [re-frame.core :as rf]
            [quuppa.date-time.core :as date-time]
            [quuppa.utils :as utils]
            [quuppa.ui.layout :as layout]
            [quuppa.ui.modal :as modal]
            [quuppa.ui.dropdown :as dropdown]
            [reagent.core :as r]))

(def current-log-file-name "qpe.json")

(defn delete-confirmation-dialog [qpe-dispatch filename]
  (when (js/confirm (str "You sure want to delete file: " filename " ?"))
    (qpe-dispatch [:qpe/req-logfile-delete filename])))

(defn delete-file [qpe-identity file-type filename]
  (when (js/confirm (str "You sure want to delete file: " filename " ?"))
    (case file-type
      "data-player-recording" (rf/dispatch [:qpe/req-data-player-file-delete qpe-identity filename])
      "binary-log" (rf/dispatch [:qpe/req-binarylog-file-delete qpe-identity filename])
      "output-data" (rf/dispatch [:qpe/req-output-data-file-delete qpe-identity filename])
      nil)))

(defn log-download-href
  ([qpe-identity logfile-name] (log-download-href qpe-identity :generic logfile-name))
  ([qpe-identity log-type logfile-name]
   (str "/qpe/"
        qpe-identity
        (case log-type
          :output-data "/qsm/output-data-files/download/"
          :binary-log "/qsm/binarylogs/download/"
          :data-player-recording "/qsm/data-player-recordings/download/"
          "/qsm/log-file/")
        logfile-name)))

(defn download-log-button [props {:keys [qpe-identity logfile-name]} & children]
  (into [:a.btn.btn-primary
         (merge {:download true
                 ;; FIXME: hardcoded href, could use reitit.router + rfe/href or such
                 :href     (log-download-href qpe-identity logfile-name)}
                props)]
        (if (not-empty children)
          children
          ["Download"])))

(defn log-item-menu [{:keys [qpe-identity filename log-type]}]
  [dropdown/dropdown
   [dropdown/menu-icon-toggle]
   [dropdown/menu
    [dropdown/item
     {:href (log-download-href qpe-identity log-type filename)}
     "Download"]
    [dropdown/item
     {:on-click #(delete-file qpe-identity (name log-type) filename)}
     "Delete"]]])

(defn log-table [{:keys [qpe-identity qpe-subscribe qpe-dispatch]}]
  (let [all-log-files @(qpe-subscribe [:qpe/data :logfile-list])
        log-files @(qpe-subscribe [:logging/filtered-log-files])
        log-files-loading @(qpe-subscribe [:qpe/data :logfile-list-loading])]

    (react/useEffect
      (fn []
        (if qpe-identity
          (do
            (rf/dispatch [:qpe/req-logfile-list {:qpe-identity qpe-identity}])
            (rf/dispatch [:qpe/req-current-log-subscribe {:qpe-identity qpe-identity}])

            (let [timer (js/setInterval
                          #(rf/dispatch [:qpe/req-current-log-subscribe {:qpe-identity qpe-identity}])
                          10000)]

              ;; Cleanup function
              (fn []
                (js/clearInterval timer)
                (rf/dispatch [:qpe/logfile-reset qpe-identity])
                (rf/dispatch [:qpe/req-current-log-unsubscribe {:qpe-identity qpe-identity}]))))

          ;; Cleanup function when qpe-identity is nil
          (fn [])))

      #js [qpe-identity])

    [:<>
     [layout/view-header
      {:title "Logs"
       :actions [:button.btn.btn-primary
                 {:on-click #(qpe-dispatch [:qpe/show-current-log])}
                 "Show current rolling log"]}]

     [:div.d-flex.flex-row.align-items-end
      [:div.form-group.flex-grow-1
       ;; match button height with padding
       [:label.py-2
        "Showing " (count log-files) " of " (count all-log-files) " logs"]]

      [:div.form-group.ml-4.d-flex.flex-column
       [:label "Log level"]
       (let [level->option (fn [level]
                             (if (nil? level)
                               ""
                               level))
             option->level (fn [option]
                             (if (= "" option)
                               nil
                               option))]
         [:select.form-select
          {:value (level->option @(qpe-subscribe [:qpe/data :ui :log-filters :level]))
           :on-change (fn [e]
                        (qpe-dispatch [:qpe/assoc-in [:ui :log-filters :level] (option->level (.. e -target -value))]))}
          (for [{:keys [id label]} [{:id ""
                                     :label ""}
                                    {:id    "ERROR"
                                     :label "Error"}
                                    {:id    "WARN"
                                     :label "Warning"}
                                    {:id    "INFO"
                                     :label "Info"}
                                    {:id    "DEBUG"
                                     :label "Debug"}]]
            [:option
             {:key id
              :value id}
             label])])]

      [:div.form-group.ml-4.d-flex.flex-column
       [:label "From date"]
       [:input.form-control
        {:type "date"
         :value (date-time/format-date @(qpe-subscribe [:qpe/data :ui :log-filters :start-date]))
         :on-change (fn [e]
                      (let [v (utils/parse-date (.. e -target -value))]
                        (qpe-dispatch [:qpe/assoc-in [:ui :log-filters :start-date] v])))
         :min nil
         :max (date-time/format-date @(qpe-subscribe [:qpe/data :ui :log-filters :end-date]))}]]

      [:div.form-group.ml-4.d-flex.flex-column
       [:label "To"]
       [:input.form-control
        {:type "date"
         :value (date-time/format-date @(qpe-subscribe [:qpe/data :ui :log-filters :end-date]))
         :on-change (fn [e]
                      (let [v (utils/parse-date (.. e -target -value))]
                        (qpe-dispatch [:qpe/assoc-in [:ui :log-filters :end-date] v])))
         :min (date-time/format-date @(qpe-subscribe [:qpe/data :ui :log-filters :start-date]))
         :max nil}]]
      [:div.form-group.ml-4.d-flex.flex-column
       [:button.btn.btn-primary
        {:on-click #(qpe-dispatch [:qpe/assoc-in [:ui :log-filters] nil])}
        "Clear Filters"]]]

     (if log-files-loading
       [:span.h2 "Log file list is being loaded..."]
       [:table.table.table-bordered.w-100.table-hover
        [:thead
         [:tr
          [:th "Name"]
          [:th "Date"]
          [:th "Size"]
          [:th "Level"]
          [:th]]]
        [:tbody
         (for [{log-name :name :keys [size last-modified max-level] :as log-file} log-files
               :let [max-level (if (= log-name "qpe-boot.json")
                                 "N/A"
                                 max-level)]]
           [:tr
            {:key      log-name
             :on-click #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar] {:type :log-details
                                                                     :log  log-file}])}
            [:td log-name]
            [:td (date-time/format-instant last-modified)]
            [:td (utils/format-bytes-for-log-table size)]
            [:td max-level]
            [:td.text-right
             ;; Top row click when clicking on the menu button
             {:on-click (fn [e]
                          (.stopPropagation e))}
             [dropdown/dropdown
              [dropdown/menu-icon-toggle]
              [dropdown/menu
               [dropdown/item
                {:on-click #(qpe-dispatch [:qpe/req-logfile-load log-name])}
                "Show log"]
               [dropdown/item
                {:download true
                 :href (log-download-href qpe-identity log-name)}
                "Download"]
               (when-not (or (= log-name current-log-file-name)
                             ;; Support old file name
                             (= log-name "quuppa.json"))
                 [dropdown/item
                  {:on-click #(delete-confirmation-dialog qpe-dispatch log-name)}
                  "Delete"])]]]])]])]))

(defn log-content-display [data]
  [:div.text-pre-wrap
   (map-indexed
     (fn [i line]
       [:div.log-line
        {:key   i
         :class (str "log-line-" (get line "level"))}
        (get line "@timestamp")
        " "
        [:strong (get line "level")]
        " ["
        (get line "logger_name")
        "] "
        (get line "message")
        (when-let [e (get line "stack_trace")]
          [:div.log-line-stack e])])
     data)])

(defn display-log-file
  [{:keys [qpe-subscribe qpe-dispatch qpe-identity] :as _props}]
  (when-let [{:keys [content] filename :name :as logfile} @(qpe-subscribe [:qpe/logfile-content])]
    ;; TODO: div.modal-backdrop, need to place on DOM tree top-level.
    (if (= :current-log logfile)
      (let [current-log @(qpe-subscribe [:qpe/current-rolling-log-file])]
        [modal/modal
         {:on-hide #(qpe-dispatch [:qpe/logfile-reset qpe-identity])
          :size "xl"
          :show true}
         [modal/header {:close-button true}
          [modal/title "Current log"]]
         [modal/body
          [log-content-display current-log]]])
      [modal/modal
       {:on-hide #(qpe-dispatch [:qpe/logfile-reset qpe-identity])
        :size "xl"
        :show true}
       [modal/header {:close-button true}
        [modal/title filename]]
       [modal/body
        (if (= :loading (:state logfile))
          [:div.d-flex.flex-row.justify-content-center
           [:div.spinner-border
            {:role "status"}]]
          [log-content-display content])]
       [modal/footer
        [download-log-button
         {:class "m-2"}
         {:qpe-identity qpe-identity
          :logfile-name filename}
         "Download"]
        (when-not (or (= current-log-file-name filename)
                      ;; Support old file name
                      (= "quuppa.json" filename))
          [:a.btn.btn-primary.m-2
           {:on-click #(delete-confirmation-dialog qpe-dispatch filename)}
           "Delete"])]])))

(defn log-sidebar [{:keys [qpe-subscribe qpe-dispatch]}]
  (when-let [sidebar-type @(qpe-subscribe [:qpe/data :ui :sidebar :type])]
    (case sidebar-type
      :log-details
      (let [{log-name :name, :keys [last-modified size statistics max-level]}
            @(qpe-subscribe [:qpe/data :ui :sidebar :log])

            qpe-identity @(qpe-subscribe [:qpe/data :server-info :identity])]
        [layout/sidebar
         [layout/sidebar-header
          {:title log-name
           :on-close #(qpe-dispatch [:qpe/close-sidebar])}]

         [layout/sidebar-content
          [:dl
           [:dt "Level"]
           [:dd max-level]

           [:dt "Date"]
           [:dd (date-time/format-instant last-modified)]

           [:dt "Size"]
           [:dd (utils/format-bytes-for-log-table size)]

           [:dt "Records"]
           [:dd
            [:ul
             (for [[level num] statistics]
               [:li {:key level}
                [:strong num] " " (name level)])]]]

          [:div
           [:button.btn.btn-primary
            {:on-click #(qpe-dispatch [:qpe/req-logfile-load log-name])}
            "Show log"]
           [download-log-button
            {:class "ml-2"}
            {:qpe-identity qpe-identity
             :logfile-name log-name}
            "Download"]]]])
      nil)))

(defn output-data-files-table [{:keys [qpe-subscribe qpe-dispatch]}]
  (let [search-string (r/atom "")
        debounced-search (r/atom "")
        debounce-timeout (r/atom nil)]
    (fn [{:keys [qpe-subscribe qpe-dispatch]}]
      (let [qpe-identity @(qpe-subscribe [:qpe/data :server-info :identity])
            selected-files @(qpe-subscribe [:qpe/data :ui :pe-logs :output-data-logs :selected-files])
            select-all? (or @(qpe-subscribe [:qpe/data :ui :pe-logs :select-all?]) false)
            filtered-files @(qpe-subscribe [:qpe/filtered-output-data-files
                                            @debounced-search])]

      [:<>
       [layout/view-header
        {:title "Output data files"
         :actions [:div.d-flex.flex-row.align-items-center
                   [:div.mr-4
                    [:input.form-control
                     {:type      "text"
                      :placeholder "Filter"
                      :value      (or @search-string "")
                      :on-change (fn [e]
                                   (let [value (.. e -target -value)]
                                     (reset! search-string value)
                                     (when @debounce-timeout
                                       (js/clearTimeout @debounce-timeout))
                                     (reset! debounce-timeout
                                             (js/setTimeout
                                               #(reset! debounced-search value)
                                               400))))}]]
                   [:div.mr-4.form-check
                    [:label.mr-1.form-check-label
                     {:for "select-all-output-files"}
                     "Select all"]
                    [:input.form-check-input
                     {:type "checkbox"
                      :id "select-all-output-files"
                      :checked select-all?
                      :on-change (fn [_]
                                   (qpe-dispatch [:qpe/select-all-output-data-files @debounced-search]))}]]
                   [:a
                    {:class (str "btn btn-primary"
                                 (when (not (seq selected-files))
                                   " disabled"))
                     :on-click (fn []
                                 (js/console.log "test" (gstring/format "/qpe/%s/qsm/output-data-files/download?selected-files=%s"
                                                                        qpe-identity
                                                                        (str/join "," selected-files))))
                     :download true
                     :href (gstring/format "/qpe/%s/qsm/output-data-files/download?selected-files=%s"
                                           qpe-identity
                                           (str/join "," selected-files))}
                    "Download selected"]
                   [:button.btn.btn-primary.ml-4
                    {:disabled (not (seq selected-files))
                     :on-click (fn [_]
                                 (when (js/confirm "Delete selected files?")
                                   (qpe-dispatch [:qpe/req-output-data-files-delete selected-files])))}
                    "Delete selected"]]}]

       (cond
         (empty? filtered-files)
         [:span.h6 "No output data files available!"]

         (nil? filtered-files)
         [:span.h6 "Couldn't fetch output data files!"]

         :else
         [:table.table.table-bordered.w-100.table-hover
          [:thead
           [:tr
            [:th "Name"]
            [:th]]]
          [:tbody
           (doall
             (for [{:keys [filename]} filtered-files]
               [:tr
                {:key filename}
                [:td filename]
                [:td [:input
                      {:type "checkbox"
                       :checked (contains? selected-files filename)
                       :on-change (fn [_]
                                    (qpe-dispatch [:qpe/select-log-file :output-data-logs filename]))}]]]))]])]))))

(defn binarylog-files-table [{:keys [qpe-subscribe]}]
  (let [qpe-identity @(qpe-subscribe [:qpe/data :server-info :identity])
        binarylog-files-metadata @(qpe-subscribe [:qpe/binarylog-files-metadata qpe-identity])]
    [:<>
     [layout/view-header
      {:title "Binary log files"}]

     (cond
       (empty? binarylog-files-metadata)
       [:span.h6 "No Binary Log files available!"]

       (nil? binarylog-files-metadata)
       [:span.h6 "Couldn't fetch Binary Log files!"]

       :else
       [:table.table.table-bordered.w-100.table-hover
        [:thead
         [:tr
          [:th "Name"]
          [:th]]]
        [:tbody
         (for [{:keys [filename]} binarylog-files-metadata]
           [:tr
            {:key filename}
            [:td filename]
            [:td.text-right
             {:on-click (fn [e]
                          (.stopPropagation e))}
             [log-item-menu
              {:qpe-identity qpe-identity
               :filename     filename
               :log-type     :binary-log}]]])]])]))

(defn data-player-files-table [{:keys [qpe-subscribe]}]
  (let [qpe-identity @(qpe-subscribe [:qpe/data :server-info :identity])
        data-player-files-metadata @(qpe-subscribe [:qpe/data-player-files-metadata qpe-identity])]
    [:<>
     [layout/view-header
      {:title "Data Player recordings"}]

     (cond
       (empty? data-player-files-metadata)
       [:span.h6 "No Data Player recording available!"]

       (nil? data-player-files-metadata)
       [:span.h6 "Couldn't fetch Data Player recordings!"]

       :else
       [:table.table.table-bordered.w-100.table-hover
        [:thead
         [:tr
          [:th "Name"]
          [:th]]]
        [:tbody
         (for [{:keys [filename]} data-player-files-metadata]
           [:tr
            {:key filename}
            [:td filename]
            [:td.text-right
             {:on-click (fn [e]
                          (.stopPropagation e))}
             [log-item-menu
              {:qpe-identity qpe-identity
               :filename     filename
               :log-type     :data-player-recording}]]])]])]))

(def log-types
  [{:label "System logs"
    :id :system}
   {:label "Data player"
    :id :data-player}
   {:label "Output data"
    :id :output-data}
   {:label "Binary logs"
    :id :binary-logs}
   {:label "Locator logs"
    :id :locators}
   {:label "Tag logs"
    :id :tags}])

(defn pe-lib-logs-table [{:keys [qpe-dispatch qpe-subscribe]} title log-type]
  (let [qpe-identity @(qpe-subscribe [:qpe/data :server-info :identity])
        selected-files @(qpe-subscribe [:qpe/data :ui :pe-logs log-type :selected-files])]
    [:<>
     [layout/view-header
      {:title title
       :actions [:div.d-flex.flex-row
                 [:a
                  {:class (str "btn btn-primary"
                               (when (not (seq selected-files))
                                 " disabled"))
                   :download true
                   :href (gstring/format "/qpe/%s/qsm/pe-log-archive/%s?selected-files=%s"
                                         qpe-identity
                                         (name log-type)
                                         (str/join "," selected-files))}
                  "Download selected"]
                 [:button.btn.btn-primary.ml-4
                  {:disabled (not (seq selected-files))
                   :on-click (fn [_]
                               (when (js/confirm "Delete selected files?")
                                 (qpe-dispatch [:qpe/req-delete-pe-logs {:log-type log-type
                                                                         :file-names selected-files}])))}
                  "Delete selected"]]}]
     [:table.table.table-bordered.w-100.table-hover
      [:thead
       [:tr
        [:th "Name"]
        [:th "Created at"]
        [:th "Files"]
        [:th "Folder size"]
        [:th]]]
      [:tbody
       (doall
         (for [{:keys [file-name local-date created-at directory? file-count size] :as entry} @(qpe-subscribe [:qpe/data :pe-logs log-type])]
           [:tr
            {:key (str entry)}
            [:td (if directory?
                   (str local-date "/")
                   file-name)]
            [:td created-at]
            [:td file-count]
            [:td (utils/format-bytes size)]
            [:td [:input
                  {:type "checkbox"
                   :checked (contains? selected-files file-name)
                   :on-change (fn [_]
                                (qpe-dispatch [:qpe/select-log-file log-type file-name]))}]]]))]]]))

(defn qpe-details-log [{:keys [qpe-subscribe parameters select-log-tab] :as props}]
  (let [selected-log-type (or (-> parameters :path :log-type)
                              :system)]
    [layout/section
     [:div.d-flex.flex-grow-1.flex-column
      [:ul.mt-2.px-4.nav.nav-tabs.d-flex.flex-shrink-0
       (for [{:keys [id label]} log-types]
         [:li.nav-item
          {:key id}
          [:a.nav-link
           {:href (select-log-tab {:log-type id})
            :class (when (= selected-log-type id)
                     "active")}
           label]])]

      [layout/view-content
       {:sidebar-open @(qpe-subscribe [:qpe/data :ui :sidebar :type])}
       (case selected-log-type
         :system [:f> log-table props]
         :data-player [data-player-files-table props]
         :output-data [output-data-files-table props]
         :binary-logs [binarylog-files-table props]
         :locators [pe-lib-logs-table props "Locator logs" :locator]
         :tags [pe-lib-logs-table props "Tag logs" :tag])]]

     [display-log-file props]
     [log-sidebar props]]))

(def controller
  "Log view subnavigation controller.

  Note that this controller is shared between qpe-next and qsm frontend, but they differ in the way qpe-identity is discovered.

  * In the qpe-next, the qpe-identity is stored in re-frame app-db, under :qpe-identity key
  * In the qsm, since it manages multiple qpe's, the currently selected qpe is present in the URL fragment"
  {:parameters {:path [:qpe-identity :log-type]}
   :start (fn [params]
            (let [log-type (or (:log-type (:path params))
                               :system)
                  ;; On QPE-next, path params don't have qpe-identity,
                  ;; but some of the event handlers don't need it either.
                  qpe-identity (-> params :path :qpe-identity)]
              (case log-type
                ;; System log is handled with hook from the component
                :system nil
                :output-data (rf/dispatch [:qpe/req-output-data-files-metadata {:qpe-identity qpe-identity}])
                :binary-logs (rf/dispatch [:qpe/req-binarylog-files-metadata {:qpe-identity qpe-identity}])
                :data-player (rf/dispatch [:qpe/req-data-player-files-metadata {:qpe-identity qpe-identity}])
                :locators (rf/dispatch [:qpe/req-list-pe-logs {:qpe-identity qpe-identity} :locator])
                :tags (rf/dispatch [:qpe/req-list-pe-logs {:qpe-identity qpe-identity} :tag]))))
   :stop (fn [params]
           (let [log-type (or (:log-type (:path params))
                              :system)
                 ;; On QPE-next, path params don't have qpe-identity, so the handlers need to consider that,
                 ;; by checking the argument and the :qpe-identity key in the app-db, an choosing the one that is not nil
                 qpe-identity (-> params :path :qpe-identity)]
             (case log-type
               :system nil
               :output-data (rf/dispatch [:qpe/remove-output-data-files-metadata qpe-identity])
               :binary-logs (rf/dispatch [:qpe/remove-binarylog-files-metadata qpe-identity])
               :data-player (rf/dispatch [:qpe/remove-data-player-files-metadata qpe-identity])
               :locators (rf/dispatch [:qpe/remove-pe-logs qpe-identity :locator])
               :tags (rf/dispatch [:qpe/remove-pe-logs qpe-identity :tag]))))})
